module.exports = __webpack_public_path__ + "img/BOTELLAREDBERRIES.af3be130.png";